import React from 'react';
import { Phone, Mail, MapPin, User, Building2 } from 'lucide-react';

const ClientContactInfo = ({ customerData, textColor, isIBRole }) => {
  const style = { color: textColor ? `${textColor}99` : 'inherit' };
  return (
    <div className="flex gap-8 flex-wrap">
      {isIBRole ? (
        <>
          <div className="flex items-center gap-2.5 text-gray-500" style={style}>
            <Phone className="w-3 h-3 flex-shrink-0" />
            <span>{customerData?.phone || 'N/A'}</span>
          </div>
          <div className="flex items-center gap-2.5 text-gray-500" style={style}>
            <Mail className="w-3 h-3 flex-shrink-0" />
            <span>{customerData?.email || 'N/A'}</span>
          </div>
          <div className="flex items-center gap-2.5 text-gray-500" style={style}>
            <Building2 className="w-3 h-3 flex-shrink-0" />
            <span>{customerData?.address || 'N/A'}</span>
          </div>
        </>
      ) : (
        <>
          <div className="flex items-center gap-2.5 text-gray-500" style={style}>
            <Phone className="w-3 h-3 flex-shrink-0" />
            <span>{customerData?.phone || 'N/A'}</span>
          </div>
          <div className="flex items-center gap-2.5 text-gray-500" style={style}>
            <Mail className="w-3 h-3 flex-shrink-0" />
            <span>{customerData?.email || 'N/A'}</span>
          </div>
          <div className="flex items-center gap-2.5 text-gray-500" style={style}>
            <MapPin className="w-3 h-3 flex-shrink-0" />
            <span>{customerData?.address || 'N/A'}</span>
          </div>
        </>
      )}
    </div>
  );
};

export default ClientContactInfo;